import type { BarcodeLookup, PublicBarcodeStatus, WantedItem } from './api.js';
import { EAN_RE } from './catalog.js';

/** UPC-A and its leading-zero EAN-13 representation are the same barcode. */
export function normalizeEan(code: string): string {
  const trimmed = code.trim();
  return /^\d{12}$/.test(trimmed) ? `0${trimmed}` : trimmed;
}

/** Uses the catalog's accepted EAN lengths (8, 12, 13, 14), without a checksum requirement. */
export function parseEan(code: string): string | null {
  const normalized = normalizeEan(code);
  return EAN_RE.test(normalized) ? normalized : null;
}

/** Also read/remove legacy UPC-A rows written before canonical normalization. */
export function barcodeAliases(code: string): string[] {
  const canonical = normalizeEan(code);
  return /^0\d{12}$/.test(canonical) ? [canonical, canonical.slice(1)] : [canonical];
}

/** Pass only an item that is still on the public wanted list. */
export function barcodeWantedStatus(
  barcode: BarcodeLookup,
  wanted: WantedItem | null | undefined,
): PublicBarcodeStatus {
  if (!wanted || wanted.canId !== barcode.canId) return 'not-wanted';
  if (
    (wanted.country !== null && barcode.country !== null && wanted.country !== barcode.country) ||
    (wanted.sizeMl !== null && barcode.sizeMl !== null && wanted.sizeMl !== barcode.sizeMl)
  ) return 'wrong-variant';
  if (
    (wanted.country !== null && barcode.country === null) ||
    (wanted.sizeMl !== null && barcode.sizeMl === null)
  ) return 'incomplete';
  return 'match';
}
